import {
  CheckMetadata,
  createRiskLevelMetadataItem,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { IdTamperDetection } from 'dashboard/models/check';

export const computeIdTamperDetectionMetadata = (check: IdTamperDetection): CheckMetadata => {
  const { 'editor-used': editorUsed, 'invalid-exif-tag-value': exifTag } = check.metadata || {};

  const metadata = [];

  const risks = check?.metadata?.risks;
  const portraitTamperingRiskData = createRiskLevelMetadataItem(
    'Portrait Tampering Risk',
    risks,
    'portrait_tampering',
  );

  if (portraitTamperingRiskData) {
    metadata.push(portraitTamperingRiskData);
  }

  const imageManipulatedRiskData = createRiskLevelMetadataItem(
    'Image Manipulated Risk',
    risks,
    'image_manipulated',
  );

  if (imageManipulatedRiskData) {
    metadata.push(imageManipulatedRiskData);
  }

  if (check.reasons && check.reasons.length > 0) {
    if (check.reasons.includes('image_manipulated')) {
      metadata.push({
        label: 'Detected Editor',
        value: editorUsed,
      });
    }
    if (check.reasons.includes('exif_inconsistency')) {
      metadata.push({
        label: 'Exif Tag',
        value: exifTag,
      });
    }
  }

  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};
